module.exports = __webpack_public_path__ + "img/Insightful.fc56bca4.png";